import { Component, OnInit } from '@angular/core';

@Component({
  template: require('./passageiros.component.html')
})
export class PassageirosComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/viagens/passageiros/passageiros.component.ts
 **/